<template>

    <div class="blogcardsslider-element">

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Recent posts slider</h2>


        <div class="preview-box" :style="{width : previewBoxWidth}">
            <div class="loading-bundle-blog-cards-blog-slider"><i class="fas fa-circle-notch fa-spin"></i><br><br>Loading...</div>
            <div class="bundle-blog-cards-wrapper bundle-blog-cards-slider-wrapper">
                <div 
                    class="bundle-content-slider bundle-blog-slider bundle-blog-cards " 
                    :id="'bundle-content-slider-'+settingsFromWeebly.settings.blogCardsId"
                    :class="[(settingsFromWeebly.settings.useRoundedEdge ? 'bundle-blog-cards-rounded' : null),(settingsFromWeebly.settings.hideArrows ? 'bundle-blog-slider-sin-arrows' : null)]"

                    :data-loop="settingsFromWeebly.settings.loop"
                    :data-autoplay="settingsFromWeebly.settings.autoplay"
                    :data-dots="settingsFromWeebly.settings.dots ? 'useDots' : 'hideDots'"
                    :data-autoplayspeed="settingsFromWeebly.settings.autoplaySpeed"
                    :data-blog-card-url="settingsFromWeebly.settings.blogUrl" :data-blog-card-amount="settingsFromWeebly.settings.blogCardsAmount" :data-paragraph-lines="settingsFromWeebly.settings.showLinesOfText"
                    >


                </div> 
            </div>

            <component :is="style">
                 #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-cards {
                    display: block;
                    opacity: 1;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                    height: {{settingsFromWeebly.settings.cardImageHeightDesktop}}px;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                    border-color: {{settingsFromWeebly.settings.cardBorderColor}};
                    background: {{settingsFromWeebly.settings.cardBg}};
                    width: calc({{100 * 1/settingsFromWeebly.settings.desktopAmountPerRow}}% - 20px );
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-readmore-icon {
                    background: {{settingsFromWeebly.settings.readmoreBg}};
                    color: {{settingsFromWeebly.settings.readmoreColor}};
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card:hover .bundle-blog-card-readmore-icon {
                    background: {{settingsFromWeebly.settings.readmoreBgHover}};
                    color: {{settingsFromWeebly.settings.readmoreColorHover}};
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card .bundle-blog-card-text {
                    color: {{settingsFromWeebly.settings.blogcardTextColor}};
                    font-family: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontNameText : settingsFromWeebly.settings.fontFamilyText}};
                    font-style: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontStyleText : settingsFromWeebly.settings.fontStyleText}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontWeightText : settingsFromWeebly.settings.fontWeightText}};
                    line-height: {{settingsFromWeebly.settings.lineHeightText}};
                    height: {{settingsFromWeebly.settings.showLinesOfText * settingsFromWeebly.settings.lineHeightText}}em;
                    max-height: {{settingsFromWeebly.settings.showLinesOfText * settingsFromWeebly.settings.lineHeightText}}em;
                    font-size: {{settingsFromWeebly.settings.cardTextFontSize}}px;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card h4 {
                    color: {{settingsFromWeebly.settings.blogcardTitleColor}};
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}};
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}};
                    font-size: {{settingsFromWeebly.settings.cardTitleFontSize}}px;
                    line-height: {{settingsFromWeebly.settings.lineHeightTitle}};
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-text:before {
                    background: {{settingsFromWeebly.settings.cardBg}};
                    background: linear-gradient(to right, rgba(255,255,255,0) 0%,{{settingsFromWeebly.settings.cardBg}} 60%);
                    height: {{settingsFromWeebly.settings.lineHeightText}}em;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link {
                    text-align: {{settingsFromWeebly.settings.filterAlignement}};
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a {
                    border-color: {{settingsFromWeebly.settings.filterItemBorderColor}};
                    color: {{settingsFromWeebly.settings.filterItemColor}};
                    background: {{settingsFromWeebly.settings.filterItemBg}};
                    font-family: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontNameText : settingsFromWeebly.settings.fontFamilyFilter}};
                    font-style: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontStyleFilter : settingsFromWeebly.settings.fontStyleFilter}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontWeightFilter : settingsFromWeebly.settings.fontWeightFilter}};
                    font-size: {{settingsFromWeebly.settings.cardFilterFontSize}}px;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a:hover,
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a.active {
                    border-color: {{settingsFromWeebly.settings.filterItemBorderColorHover}};
                    color: {{settingsFromWeebly.settings.filterItemColorHover}};
                    background: {{settingsFromWeebly.settings.filterItemBgHover}};
                }

                @media(max-width:768px){
                    #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                        width: calc({{100 * 1/settingsFromWeebly.settings.tabletAmountPerRow}}% - 20px );
                    }
                }

                @media(max-width:576px){
                    #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                        width: calc({{100 * 1/settingsFromWeebly.settings.phoneAmountPerRow}}% - 20px );
                    }
                }

                .bundle-blog-slider {
                    position: relative;
                    overflow: hidden;
                }
                .bundle-blog-slider, .bundle-blog-slider:focus, .bundle-blog-slider:active {
                    outline: none;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button {
                    position: absolute;
                    top: 0;
                    transform: none;
                    width: 30px;
                    height: 30px;
                    border-radius: {{settingsFromWeebly.settings.arrowRadius}}px;
                    background: {{settingsFromWeebly.settings.arrowBg}};
                    border: 0;
                    text-align: center;
                    padding: 0;
                    transition: all .3s ease-out;
                    outline: none!important;
                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button.previous {
                    right: 55px;
                    left: auto;
                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button.next {
                    right: 20px;
                }

                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider:hover .flickity-button.flickity-prev-next-button {

                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider:hover .flickity-button.flickity-prev-next-button.next {

                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider:hover .flickity-button.flickity-prev-next-button.previous {

                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button:hover {
                    background: {{settingsFromWeebly.settings.arrowBgHover}};
                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button[disabled]{
                    opacity: 0.3;
                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button-icon {
                    fill: {{settingsFromWeebly.settings.arrowColor}};
                    height: 14px;
                    width: auto;
                    position: static;
                }
                #bundle-content-slider-{{settingsFromWeebly.settings.blogCardsId}}.bundle-blog-slider .flickity-button.flickity-prev-next-button:hover .flickity-button-icon {
                    fill: {{settingsFromWeebly.settings.arrowColorHover}};
                }

            </component>


        </div>

        <div class="preview-box-for-styling" :style="{width : previewBoxWidth}">
            <div class="preview-box-for-styling--inner">
                <div class="bundle-blog-cards-wrapper" :class="[(settingsFromWeebly.settings.useRoundedEdge ? 'bundle-blog-cards-rounded' : null),(settingsFromWeebly.settings.hideArrows ? 'bundle-blog-slider-sin-arrows' : null)]" :id="'bundle-blog-cards-wrapper'+settingsFromWeebly.settings.blogCardsId">
                    
                    <div 
                    class="bundle-content-slider-preview bundle-blog-slider bundle-blog-cards" 
                    :id="'bundle-content-slider-'+settingsFromWeebly.settings.blogCardsId"
                    :class="settingsFromWeebly.settings.useRoundedEdge ? 'bundle-blog-cards-rounded' : null"

                    :data-loop="settingsFromWeebly.settings.loop"
                    :data-autoplay="settingsFromWeebly.settings.autoplay"
                    :data-autoplayspeed="settingsFromWeebly.settings.autoplaySpeed"
                    :data-blog-card-url="settingsFromWeebly.settings.blogUrl" :data-blog-card-amount="settingsFromWeebly.settings.blogCardsAmount" :data-paragraph-lines="settingsFromWeebly.settings.showLinesOfText"
                    :data-dots="settingsFromWeebly.settings.dots ? 'useDots' : 'hideDots'"
                    >

                        <div class="bundle-blog-block-card" v-for="(card, index) in parseInt(settingsFromWeebly.settings.blogCardsAmount)" :key="index">
                            <div class="bundle-blog-card-image" style="background-image:url(https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg)"></div>
                            <h4 class="bundle-blog-card-title">Your blog title will go here</h4>
                            <div class="bundle-blog-card-text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.</div>
                            <div class="bundle-blog-card-readmore-icon">+</div>
                        </div>

                    </div>
                </div>
            </div><!-- preview-box-for-styling--inner -->
        </div><!-- preview-box-for-styling -->

        <div class="loading-overlay" v-if="creatingSlide">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Creating new slide
                </div>
            </div>
                
        </div>

        <div class="loading-overlay" v-if="loadingSlider">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Loading slider
                </div>
            </div>
                
        </div>

    </div>

</template>

<script>

export default {

    name: 'BlogcardsSlider',

    data () {

        return {
            style: 'style',
            script: 'script',
            creatingSlide: false,
            loadingSlider: true
        }
    },

    components: {

        'vscript': {
            render: function (createElement) {

                return createElement('script', this.$slots.default)
                
            }
        }
    },

    methods: {

        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        },  

        flickityStart: function() {
            setTimeout(()=> {
                // settings
                var wrapAround = this.$store.state.weeblySettings.settings.loop == 'true' || this.$store.state.weeblySettings.settings.loop == true ? true : false
                var autoplay = this.$store.state.weeblySettings.settings.autoplay
                var autoplayspeed = this.$store.state.weeblySettings.settings.autoplaySpeed
                console.log('autoplay: ',autoplay + ' '+ 'autospeed ',autoplayspeed)

                var flkty = new Flickity( '.bundle-content-slider-preview', {
                    wrapAround: wrapAround,
                    autoPlay: autoplay ? autoplayspeed : false,
                    groupCells: true,
                    pageDots: false
                });
            },500)
        },

        reloadFlickity() {
            // create it to destroy it
            var flkty = new Flickity( '.bundle-content-slider-preview');
            // destroy it
            flkty.destroy();

            this.flickityStart()

        }

    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        }

    },
    
    mounted() {
        console.log('blog post slider', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active');

        // 
        setTimeout(()=> {
            this.flickityStart()
            this.loadingSlider = false
        }, 2000)



    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';


.preview-box-for-styling {
    padding: 75px 15px;
    background: #fff;
    border-radius: 0.25rem;
    margin: 0 auto;
    -webkit-transition: width 0.15s ease-out;
    transition: width 0.15s ease-out;
    margin-bottom: 15px;

    .preview-box-for-styling--inner {
        max-width: 985px;
        margin: 0 auto;
    }

    .bundle-blog-cards {
        opacity: 1;
    }
    .bundle-blog-cards-link {
        display: block;

    }
}
.blogcardsslider-element {
    .preview-box {
        display: none;
    }
}

.slider-actions {

    list-style: none;
    margin: 0;
    padding: 0;
    margin-bottom: 30px;

    li {
        padding: 0px 15px;
        height: 31px;
        line-height: 31px;
        display: inline-block;
        border: 1px solid @border_grey_medium;
        cursor: pointer;
        border-radius: .25rem;
        background: #fff;
        font-size: 12px;
        font-weight: 700;
        text-transform: capitalize;
        margin: 7px 7px 7px 0;

        &.add-slide-btn {
            font-weight: 700;
            width: 50px;
            height: 50px;
            line-height: 50px;
            border-radius: 50%;
            padding: 0;
            margin: 0;
            font-size: 20px;
            -webkit-box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
            box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
            -webkit-transition: all 0.3s ease-out;
            transition: all 0.3s ease-out;
            background: #4CC195;
            border: 0;
            text-align: center;
            color: #fff;
            margin-right: 7px;

            &:hover {
                -webkit-transform: translateY(-4px);
                transform: translateY(-4px);
                -webkit-box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
                box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
                background: rgba(76, 193, 149, 0.9);
            }
        }
        
    }

}

</style>



// WEBPACK FOOTER //
// src/components/elements/BlogcardsSlider.vue